<aside class="col-md-12 mb-md-0 mb-12 h-100">
  <div class="container-list h-100">
    <div class="container-list-header">
      <div class="row">
        <div class="col-md-12 d-flex align-items-center city-list-header">
          <app-autocomplete-city class="flex-fill" [inputFormControl]="cityControl" [options]="optionsCity">
        </app-autocomplete-city>
          <app-transport-company-context [initialNit]="initialTransportNit"
            (companyChange)="onTransportCompanyChange($event)">
          </app-transport-company-context>
        </div>
      </div>
    </div>
    <div class="container-list-body" infinite-scroll [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
      <div class="col-md-12 mb-md-0 mb-12" *ngFor="let City of listCities;">
        <app-city-item [city]="City" [transportNit]="transportNit"></app-city-item>
      </div>
    </div>
  </div>
</aside>
